export const siteSettings = {
  name: "Stealth Finex",
  link: "https://stealthfinex.net",
  email: "support@stealthfinex.net",
  appLink: "https://app.stealthfinex.net",
};
